import { getParent } from 'mobx-state-tree';
import { AbstractQuestion } from '../../question-data-model/Question/abstract-question.store';
import { ERROR_NEED_OVERRIDE } from '../../question-data-model/constants';

export const TestQuestionStore = AbstractQuestion.named('TestQuestionStore')
  .actions((self) => ({
    onAnswerQuestion() {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
  }))
  .views((self) => ({
    isAnswered() {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
  }))
  .views((self) => ({
    get formattedQuestionNo(): number {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get groupName(): string {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get bottomBarQuestionNoes(): [
      {
        no: number;
        answered: boolean;
      }
    ] {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get questionCount(): number {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    get answerCount(): number {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },
    prepareDataForSubmit() {
      throw new Error(`${self.type} ${ERROR_NEED_OVERRIDE}`);
    },

    get no(): number {
      let questionNo = 1;
      const test = getParent<any>(self, 6); // TODO: magic number -> refactor -> "getParent" for each model
      let isFound = false;

      test.testSections.forEach((testSection) => {
        testSection.questionGroups.forEach((group) => {
          group.questions.forEach((question) => {
            if (question.uuid === self.uuid) {
              isFound = true;
            }
            if (!isFound) {
              questionNo += question.questionCount;
            }
          });
        });
      });

      return questionNo;
    },
  }));
